import React from "react";
import "./Tracking_Details.css";
import { Table } from "react-bootstrap";
import { Link } from "react-router-dom";

function Tracking_Details({order}) {
  const productSpecifications = [
    { label: "Card Type", value: "Translucent Card - Rounded corner" },
    { label: "Orientation", value: "Landscape" },
  ];
  return (
    <>
      <div className="Tracking_Details">
        <div className="My_order_card">
          <div className="row">
            {/* Tracking Details Section */}
            <div className="col-md-12 col-sm-12 ">
              <div className="card_inner_content card_inner_content_two  ">
                <div className="main_table_holder">
                  <div className="heading_holder">
                    <h3>Tracking Details</h3>
                    <Link to={`/job-location-details/${order?.id}`}>
                      <div className="tracking_holder">
                        <h6>Tracking URL </h6>
                        <div className="img_holder">
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/Images/Icons/tracking.png"
                            }
                            className="tracking_img"
                            alt="tracking_img"
                          />
                        </div>
                      </div>
                    </Link>
                  </div>
                  {/* <div className="row">
                    <div className="col-md-12">
                      <div className="heading_table_holder">
                        <div className="info_table_holder">
                          <Table responsive>
                            <tbody>
                              {productSpecifications.map((spec, index) => (
                                <tr key={index}>
                                  <td>{spec.label}</td>
                                  <td>{spec.value}</td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Tracking_Details;
